import {
  READY_TO_UPLOAD,
  UPDATE_ANALYSIS_MAP,
  UPDATE_ANALYSIS_STATUS,
  UPDATE_OVERALL_ANALYSIS_STATUS,
} from './UploaderActions';

const DEFAULT_STATE = {
  analysisMap: {},
  overallAnalysisStatus: READY_TO_UPLOAD,
  privacyOn: true,
};

const actionsMap = {
  [UPDATE_ANALYSIS_STATUS]: handleAnalysisStatusUpdate,
  [UPDATE_ANALYSIS_MAP]: handleAnalysisMapUpdate,
  [UPDATE_OVERALL_ANALYSIS_STATUS]: handleOverallAnalysisUpdate,
};

export default function Uploader(state = DEFAULT_STATE, action = {}) {
  // @ts-expect-error TS(2339): Property 'type' does not exist on type '{}'.
  const { type } = action;
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (actionsMap[type]) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return actionsMap[type](state, action);
  }
  return state;
}

function handleOverallAnalysisUpdate(state: any, action: any) {
  const {
    response: { status },
  } = action;

  return {
    ...state,
    overallAnalysisStatus: status,
  };
}

function handleAnalysisMapUpdate(state: any, action: any) {
  const {
    response: { fileInfo },
  } = action;
  const { analysisMap } = state;

  const { fileName } = fileInfo;
  if (state[fileName]) {
    return {
      ...state,
    };
  }

  return {
    ...state,
    analysisMap: {
      ...analysisMap,
      [fileName]: fileInfo,
    },
  };
}

function handleAnalysisStatusUpdate(state: any, action: any) {
  const {
    response: { fileInfo, newStatus },
  } = action;
  const { analysisMap } = state;
  const { fileName } = fileInfo;

  return {
    ...state,
    analysisMap: {
      ...analysisMap,
      [fileName]: {
        ...fileInfo,
        status: newStatus,
      },
    },
  };
}
